import { ValidatorFn, FormGroup, ValidationErrors } from "@angular/forms";

export function substanceAllergyValidator(control: FormGroup): ValidationErrors | null {
    const hasAllergy = control.value.hasAllergiesToSubstances;
    const substances = control.value.allergiesCauseSubstance;
    return hasAllergy && !substances ? { "substanceMissing": true } : null;
}